import { jsx as _jsx } from "preact/jsx-runtime";
import BasketItem from '@widgets/BasketList/BasketItem';
import { Wrapper } from './styles';
function MiscItems(props) {
    const { misc } = props;
    return (_jsx(Wrapper, { children: misc.map((item, idx) => (_jsx(BasketItem, { id: item.MiscellaneousId, description: item.Description, priceBands: item.PriceBands, canEdit: item.canEdit, canDelete: item.canDelete }, item.MiscellaneousId))) }));
}
export default MiscItems;
